/**
 * Array 原型扩展工具
 * 为 JavaScript 原生 Array 添加实用方法
 *
 * 使用方式：在 main.js 中引入即可全局生效
 * import '@/config/arrayConfig'
 */

// 按值移除数组元素
Array.prototype.remove = function (value) {
  let index = this.indexOf(value)
  if (index > -1) {
    this.splice(index, 1)
  }
  return index
}

// 移除对象数组中匹配指定 key 的元素
Array.prototype.removeByKey = function (key, val) {
  let index = this.findIndex(value => value[key] === val)
  if (index > -1) {
    this.splice(index, 1)
  }
  return index
}

// 对象数组转 Map
Array.prototype.toMap = function (key) {
  let map = new Map()
  this.forEach(v => map.set(v[key], v))
  return map
}
